import KTLayoutContent from 'assets/plugins/ktcontent';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

KT01Content.propTypes = {
  isFullScreen: PropTypes.bool,
};

function KT01Content({ isFullScreen = false, ...props }) {
  useEffect(() => {
    KTLayoutContent.init('kt_content');
  }, []);

  return (
    <div
      id="kt_content"
      className={`content d-flex flex-column flex-column-fluid ${isFullScreen ? 'p-0' : ''}`}
    >
      {props.children}
    </div>
  );
}

export default KT01Content;
